const BackIcon = ({ color }: any) => {
    return (
        <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.90036 9.40032C6.14443 9.15624 6.14443 8.76051 5.90036 8.51643L2.17563 4.79171L5.90036 1.06698C6.14443 0.822905 6.14443 0.427176 5.90036 0.183099C5.65628 -0.0609789 5.26055 -0.0609789 5.01647 0.183099L0.849806 4.34977C0.605729 4.59384 0.605729 4.98957 0.849806 5.23365L5.01647 9.40032C5.26055 9.64439 5.65628 9.64439 5.90036 9.40032Z" fill="#141A4D"/>
        </svg>
    )
  }
  
  export default BackIcon